export default __webpack_public_path__ + "static/media/DJI_0940.MP4.00_04_55_14.Still013.0987284c.jpg";